import { Tooltip, IconButton, Icon } from "@mui/material";
import CallEndIcon from "@mui/icons-material/CallEnd";
import HearingIcon from "@mui/icons-material/Hearing";
import GroupsIcon from "@mui/icons-material/Groups";
import LogoutIcon from "@mui/icons-material/Logout";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import LoginIcon from "@mui/icons-material/Login";

const ACTIONS = [
  { type: 1, label: "Barging" },
  { type: 2, label: "Coaching" },
  { type: 3, label: "TPC" },
  { type: 4, label: "Log-Out" },
  { type: 5, label: "On-Break" },
  { type: 6, label: "Log-In" },
];

const RowActionButtons = ({
  getDataURL,
  row,
  activeAction,
  onActionClick,
  ActionPerform,
}) => {
  const allowedURLs = ["/acdRealTime/agents"];
  const shouldShowIcon = allowedURLs.includes(getDataURL);
  if (
    !["Talk", "Break", "Idle", "Log Out", "NTC", "Logout"].includes(
      row?.liveState
    )
  )
    return null;

  return (
    <>
      {ACTIONS.map((action) => {
        const isActive =
          activeAction &&
          activeAction.sessionUuid === row.sessionUuid &&
          activeAction.type === action.type;
        const isDisabled =
          ([1, 2, 3].includes(action.type) && row.liveState !== "Talk") ||
          (action.type === 6 && row.liveState !== "Log Out") || (action.type === 5 && row.liveState === "Log Out")

        const handleClick = () => {
          if (isDisabled) return;

          if (action.type === 4 || action.type === 5 || action.type === 6) {
            ActionPerform(row, action.type);
          } else {
            onActionClick(row, action.type);
          }
        };

        let IconComponent = null;

        if (isActive) {
          IconComponent = <CallEndIcon fontSize="medium" color="error" />;
        } else if (action.type === 1) {
          IconComponent = <HearingIcon fontSize="medium" color="success" />;
        } else if (action.type === 2) {
          IconComponent = (
            <Icon fontSize="medium" sx={{ color: "#fb8c00" }}>
              spatial_audio_off
            </Icon>
          );
        } else if (action.type === 3) {
          IconComponent = (
            <GroupsIcon fontSize="medium" sx={{ color: "#f50057" }} />
          );
        } else if (action.type === 4 && shouldShowIcon) {
          IconComponent = (
            <LogoutIcon fontSize="medium" sx={{ color: "#f50057" }} />
          );
        } else if (action.type === 5 && shouldShowIcon) {
          IconComponent = (
            <StopCircleIcon fontSize="medium" sx={{ color: "#b28704" }} />
          );
        } else if (action.type === 6 && shouldShowIcon) {
          IconComponent = (
            <LoginIcon fontSize="medium" sx={{ color: "#357a38" }} />
          );
        }
        if (!IconComponent) return null;

        return (
          <Tooltip key={action.type} title={action.label} arrow>
            <IconButton
              size="small"
              onClick={handleClick}
              disabled={isDisabled}
              sx={{
                color: "#fff",
                borderRadius: "4px",
                padding: "4px",
                mr: 0.5,
                "&:hover": { backgroundColor: "#e3f2fd" },
                "&.Mui-disabled": {
                  opacity: 0.5,
                  color: "#fff",
                },
              }}
            >
              {IconComponent}
            </IconButton>
          </Tooltip>
        );
      })}
    </>
  );
};

export default RowActionButtons;
